<template>
  <div id="app">
    <router-view />
    <!-- GoTop、KanonBookingModal 都是移动端专属的全局挂件（小尺寸悬浮按钮/移动端样式的
         预约弹窗）——PC 端（合并自 huayin-pc，/pc 开头的路由）自己在页面里有一套对应的
         东西（KanonAppointmentModal 等），不需要、也不该再叠一层移动端的这些控件上去 -->
    <template v-if="!isPcRoute">
      <GoTop />
      <KanonBookingModal />
    </template>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  computed: {
    isPcRoute() {
      return this.$route.path === "/pc" || this.$route.path.startsWith("/pc/");
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
* a {
  color: black;
  text-decoration: none;
}
* {
  margin: 0;
  padding: 0;
}
</style>
